
import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import moment from 'moment';

@Component({
  model: { prop: 'value', event: 'input' },
})
export default class DatePickerSingle extends Vue {
  @Prop({ default: null }) value!: string | null; // esperado: 'YYYY-MM-DDTHH:mm:ss' por defecto

  @Prop({ default: false }) outlinedInput!: boolean;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: 'Fecha' }) label!: string;
  @Prop({ default: false }) requireConfirmation!: boolean;
  @Prop({ default: '' }) placeholder!: string;
  @Prop({ default: undefined }) heightInput!: string | undefined;
  @Prop({ default: 'mdi-calendar' }) prependIcon!: string;
  @Prop({ default: undefined }) widthInput!: string | undefined;
  @Prop({ default: false }) clearable!: boolean;

  @Prop({ default: null }) min!: string | null;
  @Prop({ default: null }) max!: string | null;

  @Prop({ default: 'YYYY-MM-DDTHH:mm:ss' }) formatOut!: string; // cómo se emite
  @Prop({ default: 'YYYY-MM-DDTHH:mm:ss' }) formatIn!: string;  // cómo se recibe
  @Prop({ default: 'DD/MM/YYYY' }) displayFormat!: string;      // cómo se muestra

  @Prop({ default: true }) keepTimeFromValue!: boolean;
  @Prop({ default: '00:00:00' }) defaultTimeOnSelect!: string;

  menu: boolean = false;

  // Estado interno:
  tempDateYMD: string | null = null;
  textFieldValue: string = '';
  lastTimePart: string | null = null;

  get minDateYMD(): string | null {
    return this.normalizeToYMD(this.min);
  }
  get maxDateYMD(): string | null {
    return this.normalizeToYMD(this.max);
  }

  @Watch('value', { immediate: true })
  onValueChange(newVal: string | null) {
    this.assignFromExternal(newVal);
  }

  assignFromExternal(val: string | null) {
    if (val) {
      let m = moment(val, this.formatIn, true);
      if (!m.isValid()) m = moment(val); // fallback (ISO, etc.)

      if (m.isValid()) {
        this.tempDateYMD   = m.format('YYYY-MM-DD');
        this.textFieldValue= m.format(this.displayFormat);
        this.lastTimePart  = m.format('HH:mm:ss');

        const normalizedOut = m.format(this.formatOut);
        if (normalizedOut !== val) {
          this.emitInput(normalizedOut);
        }
        return;
      }
    }
    this.tempDateYMD = null;
    this.textFieldValue = '';
    this.lastTimePart = null;
    if (val !== null) this.emitInput(null);
  }

  normalizeToYMD(val: string | null): string | null {
  if (!val) return null;

  const tryStrict = (v: string, fmt?: string) =>
    fmt ? moment(v, fmt, true) : moment.invalid();

  let m = tryStrict(val, this.formatIn);

  if (!m.isValid()) m = tryStrict(val, this.formatOut);

  if (!m.isValid()) m = moment(val, 'YYYY-MM-DD', true);

  if (!m.isValid()) m = moment(val);

  return m.isValid() ? m.format('YYYY-MM-DD') : null;
}


  onNativeChange(newVal: string | null) {
    this.tempDateYMD = newVal;
    this.$emit('date-selected', newVal);
    this.confirmAndEmit();
    this.menu = false;
    }

  onConfirm() {
    this.confirmAndEmit();
    this.menu = false;
  }

  onCancel() {
    this.assignFromExternal(this.value);
    this.menu = false;
  }

  confirmAndEmit() {
    if (this.tempDateYMD) {
      let hhmmss = this.defaultTimeOnSelect;
      if (this.keepTimeFromValue && this.lastTimePart) {
        hhmmss = this.lastTimePart;
      }

      const combined = moment(this.tempDateYMD + ' ' + hhmmss, 'YYYY-MM-DD HH:mm:ss', true);
      if (combined.isValid()) {
        this.textFieldValue = combined.format(this.displayFormat);
        const out = combined.format(this.formatOut);
        this.emitInput(out);
        this.lastTimePart = combined.format('HH:mm:ss');
        return;
      }
    }

    this.textFieldValue = '';
    this.emitInput(null);
  }

  clearValue() {
    this.tempDateYMD = null;
    this.textFieldValue = '';
    this.lastTimePart = null;
    this.emitInput(null);
  }

  @Emit('input')
  emitInput(val: string | null) {}
}
